import React, { FC } from 'react';

import classnames from 'classnames';
import styles from './chip.module.scss';

type Props = {
  color: 'secondary' | 'success' | 'warning' | 'future' | 'primary';
  testId?: string;
};

export const Chip: FC<Props> = ({ children, color, testId = '' }) => (
  <span
    className={classnames(styles.container, {
      [styles.information]: color === 'secondary',
      [styles.success]: color === 'success',
      [styles.warning]: color === 'warning',
      [styles.future]: color === 'future',
      [styles.primary]: color === 'primary',
    })}
    data-test-id={testId}
  >
    {children}
  </span>
);
